import React from "react";
import live from "./img/live.png";
import project from "./img/problem.png";
import problem from "./img/problemsolving.png";
import support from "./img/support.png";
import "./css/Why.css";

const WhyImage = [
  {
    id: 1,
    icon: live,
    text: "Live Classes",
  },
  {
    id: 2,
    icon: project,
    text: "Live Project",
  },
  {
    id: 3,
    icon: problem,
    text: "Problem Solving",
  },
  {
    id: 4,
    icon: support,
    text: "24 * 7 Support",
  },
];

function Why() {
  return (
    <div className="why">
      <div className="why-content">
        <p>Why Choose Us ?</p>
        <div className="why-content-img">
          {WhyImage.map((data) => (
            <>
              <div id={data.id} className="why-img-container">
                <div className="container-img">
                  {<img src={data.icon} alt="live" />}
                  <p>{data.text}</p>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Why;
